import { getEnvSetting } from "./utils/env";

export const addInstitutionsQuerystring = (path, params) => {
  const {
    freetext,
    categories = [],
    districts = [],
    offborders = false
  } = params;
  if (!freetext && !categories.length && !districts.length) {
    return path;
  }

  return [
    `${path}?`,
    `freetext=${freetext}`,
    `offborders=${offborders}`,
    `districts=${districts.join(",")}`,
    `categories=${categories.join(",")}`
  ].join("&");
};

const request = (
  method = "GET",
  path = "/",
  params = {},
  data = {},
  jsonify = true,
  extra_headers = {}
) => {
  let request_struct = {
    method: method,
    headers: {
      Accept: "application/json",
      ...extra_headers
    }
  };

  if (jsonify) {
    request_struct.headers["Content-Type"] = "application/json";
  }

  if (["POST", "PATCH", "PUT"].find(x => x === method)) {
    if (jsonify) {
      request_struct["body"] = JSON.stringify(data);
    } else {
      request_struct["body"] = data;
    }
  }

  return fetch(getEnvSetting("REACT_APP_API_URL") + path, request_struct);
};

export const loadInstitutions = (token, params) => {
  const extra = token ? { Authorization: token } : {};
  return request(
    "GET",
    addInstitutionsQuerystring("/entries", params),
    {},
    {},
    true,
    extra
  );
};

export const loadInstitution = (token, key) => {
  const extra = token ? { Authorization: token } : {};
  return request("GET", `/entries/${key}`, {}, {}, true, extra);
};

export const loadCategories = () => request("GET", "/categories");
export const loadDistricts = () => request("GET", "/districts");
export const login = (username, password) =>
  request("POST", "/login", null, { username, password });
export const loadUsers = token =>
  request("GET", "/users", {}, {}, true, { Authorization: token });
export const loadUser = token =>
  request("GET", "/user", {}, {}, true, { Authorization: token });
export const saveInstitution = (token, data) => {
  const method = data._key ? "PATCH" : "POST";
  return request(method, "/entries", {}, data, true, { Authorization: token });
};
export const saveUser = (token, data) => {
  const method = data._key ? "PATCH" : "POST";
  const headers = token ? { Authorization: token } : {};
  return request(method, "/users", {}, data, true, headers);
};

export const validateRegistration = hash => {
  return request("POST", "/confirm-registration", {}, { hash });
};

export const requestPassword = email => {
  return request("POST", "/request-password", {}, { email });
};

export const resetPassword = data => {
  return request("POST", "/reset-password", {}, data);
};



/** WEBPACK FOOTER **
 ** ./src/api.js
 **/